export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14204.3b933113.jpg";